import ListGroup from 'react-bootstrap/ListGroup';
import { Row, Col } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>

                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/committees" className="mb-3 p-3">
                            {/* <i className="fas fa-chevron-circle-right me-3"></i> 
                            <img className='ms-1' src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="36" height="20" />
                            */}
                            <b>Committees</b>
                        </ListGroup.Item>
                    </ListGroup>

                    <ListGroup>

                    <ListGroup.Item as={Link} action to="/internalcomplaintcommittee" className={`p-3 ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Internal Complaint Committee  
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/grievance_redressal_committee" className={`p-3 ${activeIndex == 9 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Grievance Redressal Committee  
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/anti-ragging" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Anti-Ragging Committee  
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/liaison-officers" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            SC/ST/OBC Liaison Officers/Cell   
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/differently_abled_support_service_cell" className={`p-3 ${activeIndex == 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Differently Abled Support Service Cell
                        </ListGroup.Item>

                         <ListGroup.Item as={Link} action to="/senior-purchase-committee" className={`p-3 ${activeIndex == 8 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Senior Purchase Committee
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/Timetable_Committee" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Timetable Committee
                        </ListGroup.Item>  

                        <ListGroup.Item as={Link} action to="/equal_opportunity_cell" className={`p-3 ${activeIndex == 5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Equal Opportunity Cell
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/disciplinary_welfare_committee" className={`p-3 ${activeIndex == 6 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Disciplinary and Welfare Committee
                        </ListGroup.Item> 
                        <ListGroup.Item as={Link} action to="/overseeing_waste_management_system" className={`p-3 ${activeIndex == 7 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Overseeing Waste Management System
                        </ListGroup.Item> 
                        <ListGroup.Item as={Link} action to="/school_management_committee" className={`p-3 ${activeIndex == 10 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            School Management Committee
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/outsourcing_contractual_adhoc_employee_committee" className={`p-3 ${activeIndex == 11 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Outsourcing / Contractual / Adhoc Employee Committee
                        </ListGroup.Item> 

                         <ListGroup.Item as={Link} action to="/mental_health_and_well_being_monitoring_committee" className={`p-3 ${activeIndex == 12 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Mental Health and Well-being Monitoring Committee
                        </ListGroup.Item>   
                        <ListGroup.Item as={Link} action to="/obc_cell" className={`p-3 ${activeIndex == 13 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            OBC CELL
                        </ListGroup.Item> 
                        <ListGroup.Item as={Link} action to="/Library_Advisory_Committee" className={`p-3 ${activeIndex == 14 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Library Advisory Committee
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/Service_Matters_Committee" className={`p-3 ${activeIndex == 15 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Service Matters Committee
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/RPN_Committee" className={`p-3 ${activeIndex == 16 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            RPN, Creation of Posts and Roster Verification Committee
                        </ListGroup.Item>   




                       

                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;

